// import { FaArrowRight } from "react-icons/fa6";
// import { featuredProductsData } from "../../../lib/constants/ConstantsData";
// import { useNavigate } from "react-router-dom";

// const FeatureProducts = () => {
//   const navigate = useNavigate();
//   const toProducts = () => {
//     navigate("/products");
//   };
//   return (
//     <div className="sm:my-30 mx-auto my-5 w-[90%] px-4 pt-[8%] sm:max-w-xl sm:pt-[15%] md:my-40 md:max-w-[700px] lg:my-20 lg:max-w-4xl xl:max-w-6xl xl:pt-[12%] 2xl:max-w-7xl">
//       <div className="flex flex-col items-center justify-between text-center md:flex-row md:text-left">
//         <div className="mb-6 md:mb-0">
//           <h5 className="text-base font-semibold uppercase text-gray-500 sm:text-lg">
//             Our Products
//           </h5>
//           <h2 className="font-heading text-2xl font-bold uppercase text-black sm:text-3xl md:text-4xl lg:text-5xl">
//             Our Featured Products
//           </h2>
//         </div>
//       </div>

//       {/* Product Cards */}
//       <div className="-mx-4 mt-8 grid grid-cols-1 gap-6 sm:-mx-6 sm:mt-10 sm:grid-cols-2 sm:gap-8 md:gap-10">
//         {featuredProductsData.map((item, index) => (
//           <div
//             key={index}
//             className="relative h-[300px] w-full overflow-hidden rounded-2xl bg-featureProBg bg-cover bg-no-repeat sm:h-[400px] md:h-[450px] lg:h-[500px]"
//           >
//             <img
//               className="absolute -bottom-[1px] -left-[1px] h-[200px] w-[200px] object-cover sm:-bottom-[58px] sm:-left-[2px] sm:h-[300px] sm:w-[200px] md:-bottom-[60px] md:h-[350px] md:w-[250px] lg:-bottom-[58px] lg:h-[400px] lg:w-[300px] xl:h-[400px] xl:w-[400px]"
//               src={item.imgUrl}
//               alt={item.alt}
//             />
//             <div className="absolute right-[1rem] top-8 flex flex-col items-center justify-center text-white sm:right-10 sm:top-10 md:right-14 md:top-12">
//               <h3 className="mb-2 py-2 text-center font-heading text-lg font-bold uppercase sm:mb-3 sm:py-3 sm:text-xl md:mb-4 md:py-4 md:text-2xl lg:text-[2rem]">
//                 {item.heading}
//               </h3>
//               <button
//                 onClick={toProducts}
//                 className="xl:w-[164px]sm:w-[126px] flex h-[45px] w-[150px] cursor-pointer items-center justify-center gap-2 rounded-full bg-white text-black transition-all duration-300 sm:h-[40px] lg:w-[154px]"
//               >
//                 {item.btnText}
//                 <FaArrowRight />
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default FeatureProducts;


import { FaArrowRight } from "react-icons/fa6";
import { featuredProductsData } from "../../../lib/constants/ConstantsData";
import { useNavigate } from "react-router-dom";

const FeatureProducts = () => {
  const navigate = useNavigate();
  const toProducts = () => {
    navigate("/products");
  };
  return (
    <div className=" h-[800px] sm:h-[700px] md:h-[800px] lg:h-[900px] xl:h-[1000px] 2xl:h-[1100px] sm:my-30 mx-auto my-2 w-[90%] px-4   sm:max-w-xl  mt-[-30px] md:mt-[-20px] lg:mt-[-40px] md:max-w-[700px] lg:max-w-4xl xl:max-w-6xl xl:pt-[12%] 2xl:max-w-7xl sm:pt-40 pt-32">
      <div className="flex flex-col items-center justify-between text-center ">
        <div className="mb-6 md:mb-0">
          <h5 className="text-base font-sfPro font-semibold uppercase text-gray-500 sm:text-lg">
            obscura mfg store
          </h5>
          <h2 className="font-heading text-2xl font-bold uppercase text-black sm:text-3xl md:text-4xl lg:text-5xl">
            Our Featured Products
          </h2>
        </div>
      </div>

      {/* Product Cards */}
      <div className="-mx-4 mt-8 grid grid-cols-1 gap-6 sm:-mx-6 sm:mt-10 sm:grid-cols-2 sm:gap-8 md:gap-10">
        {featuredProductsData.map((item, index) => (
          <div
            key={index}
            className="relative h-[300px] w-full overflow-hidden rounded-2xl bg-featureProBg bg-cover bg-no-repeat sm:h-[400px] md:h-[450px] lg:h-[500px]"
          >
            <img
              className="absolute -bottom-[1px] -left-[1px] h-[200px] w-[200px] object-cover sm:-bottom-[58px] sm:-left-[2px] sm:h-[300px] sm:w-[200px] md:-bottom-[60px] md:h-[350px] md:w-[250px] lg:-bottom-[58px] lg:h-[400px] lg:w-[300px] xl:h-[400px] xl:w-[400px]"
              src={item.imgUrl}
              alt={item.alt}
            />
            <div className="absolute right-[1rem] top-8 flex flex-col items-center justify-center text-white sm:right-10 sm:top-10 md:right-14 md:top-12">
              <h3 className="mb-2 py-2 text-center font-heading text-lg font-bold uppercase sm:mb-3 sm:py-3 sm:text-xl md:mb-4 md:py-4 md:text-2xl lg:text-[2rem]">
                {item.heading}
              </h3>
              <button
                onClick={toProducts}
                className="xl:w-[164px]sm:w-[126px] flex h-[45px] w-[150px] cursor-pointer items-center justify-center gap-2 rounded-full bg-white text-black transition-all duration-300 sm:h-[40px] lg:w-[154px]"
              >
                {item.btnText}
                <FaArrowRight />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureProducts;

















